import { List } from "immutable";

import { ContentType } from "@seneca/course-service-types";

import { Contents } from "../../../../../course/state";
import actionTypes from "../action-types";
import { QuestionStatType } from "../models/QuestionStat";
import { StudentAssignmentReceived } from "../models/StudentAssignmentReceived";
import { VocabularyWordStatType } from "../models/VocabularyWordStat";

export function receiveAssignmentWithContents(contents: Contents) {
  return (assignment: StudentAssignmentReceived) => {
    return {
      type: actionTypes.RECEIVE_ASSIGNMENT,
      payload: { assignment, contents }
    };
  };
}

export function receiveAssignmentsWithContents(contents: Contents) {
  return (assignments: StudentAssignmentReceived[]) => {
    return {
      type: actionTypes.RECEIVE_ASSIGNMENTS,
      payload: assignments.map(assignment => ({ assignment, contents }))
    };
  };
}

export function deleteAssignments(assignmentIds: List<string>) {
  return {
    type: actionTypes.DELETE_ASSIGNMENTS,
    payload: assignmentIds
  };
}

type SectionStatType = {
  assignmentId: string;
  sectionId: string;
  sessionScore: number;
  sessionDuration: number;
  contentType: ContentType;
  contentIds: List<string>;
};

export function updateAssignmentSectionStat(payload: SectionStatType) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_SECTION_STAT,
    payload
  };
}

export function updateAssignmentVocabularyStat(payload: {
  assignmentId: string;
  vocabularyStats: VocabularyWordStatType;
}) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_VOCABULARY_STAT,
    payload
  };
}

type ExamQuestionStatType = {
  assignmentId: string;
  questionId: string;
} & QuestionStatType;

export function updateAssignmentQuestionStat(payload: ExamQuestionStatType) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_QUESTION_STAT,
    payload
  };
}

type QuizModuleStatType = {
  moduleId: string;
  sessionMark: number;
};

type QuizStatType = {
  assignmentId: string;
  quizId: string;
  timestamp: string;
  sessionDuration: number;
  modules: QuizModuleStatType[];
};

export function updateAssignmentQuizStat(payload: QuizStatType) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_QUIZ_STAT,
    payload
  };
}
